export const VALUE_TYPE_TEXT = "TEXT";
export const VALUE_TYPE_LIST = "LIST";
export const VALUE_TYPE_NUMBER = "NUMBER";

export const DEFAULT_LIST_DELIMITER = ",";
export const DEFAULT_WEIGHT = 9;
